import request from '@/utils/request'
const prefix = '/api'
export function fetchList(params) {
    return request({
        url: '/post/list',
        method: 'get',
        params: params
    })
}

export function fetchFocus() {
    return request({
        url: '/focus/list',
        method: 'get',
        params: {}
    })
}

export function fetchCategory() {
    return request({
        url: '/category',
        method: 'get',
        params: {}
    })
}

export function fetchFriend() {
    return request({
        url: '/friend',
        method: 'get',
        params: {}
    })
}

export function fetchSocial() {
    return request({
        url: '/social',
        method: 'get',
        params: {}
    });
}

export function fetchSiteInfo() {
    return request({
        url: '/site',
        method: 'get',
        params: {}
    })
}

export function fetchComment() {
    return request({
        url: '/comment',
        method: 'get',
        params: {}
    })
}
export function articleList(data) {
    return request({
        url: prefix + '/articlesList',
        method: 'post',
        data
    })
}

export function getArticleData(data) {
    return request({
        url: prefix + '/getArticleData',
        method: 'post',
        data
    })
}

export function getLevelTestList(data) {
    return request({
        url: prefix + '/levelTestList',
        method: 'post',
        data,
        login_auth:'Y'
    })
}

export function homeworkDetail(data) {
    return request({
        url: prefix + '/homeworkDetail',
        method: 'post',
        data,
        login_auth:'Y'
    })
}

export function loginCode(data) {
    return request({
        url: prefix + '/loginCode',
        method: 'post',
        data,
        login_auth:'N'
    })
}

export function login(data) {
    return request({
        url: prefix + '/crestedIbisLogin',
        method: 'post',
        data,
        login_auth:'N'
    })
}

export function recordStuAnswer(data) {
    return request({
        url: prefix + '/recordStuAnswer',
        method: 'post',
        data,
        login_auth:'N'
    })
}

export function clearHomework(data) {
    return request({
        url: prefix + '/homework/clearHomework',
        method: 'post',
        data,
        login_auth:'N'
    })
}

export function userHomeworkReport(data) {
    return request({
        url: prefix + '/userHomeworkReport',
        method: 'post',
        data,
        login_auth:'N'
    })
}

export function realQuestionsCategoryList(data) {
    return request({
        url: prefix + '/realQuestionsCategoryList',
        method: 'post',
        data,
        login_auth:'N'
    })
}

export function realQuestionsList(data) {
    return request({
        url: prefix + '/realQuestionsList',
        method: 'post',
        data,
        login_auth:'N'
    })
}

export function specialVideoList(data) {
    return request({
        url: prefix + '/specialVideoList',
        method: 'post',
        data,
        login_auth:'N'
    })
}

export function getStuUserInfo(data) {
    return request({
        url: prefix + '/getStuUserInfo',
        method: 'post',
        data,
        login_auth:'N'
    })
}

export function userClassDetail(data) {
    return request({
        url: prefix + '/userClassDetail',
        method: 'post',
        data,
        login_auth:'N'
    })
}

export function classMemberList(data) {
    return request({
        url: prefix + '/studentsClass/classMemberList',
        method: 'post',
        data,
        login_auth:'N'
    })
}

export function applyJoinClass(data) {
    return request({
        url: prefix + '/applyJoinClass',
        method: 'post',
        data,
        login_auth:'N'
    })
}

export function homeworkStuList(data) {
    return request({
        url: prefix + '/homeworkStuList',
        method: 'post',
        data,
        login_auth:'N'
    })
}

export function classTestStuList(data) {
    return request({
        url: prefix + '/classTestStuList',
        method: 'post',
        data,
        login_auth:'N'
    })
}

export function SourceShareList(data) {
    return request({
        url: prefix + '/boutiqueResource/sourceShareList',
        method: 'post',
        data,
        login_auth:'N'
    })
}

export function albumSourceShareList(data) {
    return request({
        url: prefix + '/boutiqueResource/albumSourceShareList',
        method: 'post',
        data,
        login_auth:'N'
    })
}

export function getStuHomeworkTags(data) {
    return request({
        url: prefix + '/getStuHomeworkTags',
        method: 'post',
        data,
        login_auth:'N'
    })
}

export function activeList(data) {
    return request({
        url: prefix + '/activity/list',
        method: 'post',
        data,
        login_auth:'N'
    })
}

export function getUserAbilityActivityInfo(data) {
    return request({
        url: prefix + '/activity/getUserAbilityActivityInfo',
        method: 'post',
        data,
        login_auth:'N'
    })
}

export function getAbilityEvaluationQuestions(data) {
    return request({
        url: prefix + '/activity/getAbilityEvaluationQuestions',
        method: 'post',
        data,
        login_auth:'N'
    })
}
export function resetAbilityEvaluationRecord(data) {
    return request({
        url: prefix + '/activity/resetAbilityEvaluationRecord',
        method: 'post',
        data,
        login_auth:'N'
    })
}

export function submitAbilityEvaluationAnswer(data) {
    return request({
        url: prefix + '/activity/submitAbilityEvaluationAnswer',
        method: 'post',
        data,
        login_auth:'N'
    })
}

export function getActivityRanking(data) {
    return request({
        url: prefix + '/activity/getActivityRanking',
        method: 'post',
        data,
        login_auth:'N'
    })
}

export function getUserActiveAward(data) {
    return request({
        url: prefix + '/activity/getUserActiveAward',
        method: 'post',
        data,
        login_auth:'N'
    })
}
















